import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ['name', 'description'];

    connect() {}

    open() {
        this.element.classList.add('show', 'd-block');
        document.querySelector('body').insertAdjacentHTML('beforeend', '<div id="modal-backdrop" class="modal-backdrop fade show"></div>');
    }

    setContent(data) {
        const unit_info = JSON.parse(data.info);
        if(unit_info.name !== undefined && unit_info.description !== undefined){
            this.nameTarget.innerHTML = unit_info.name + ' Unit';
            this.descriptionTarget.innerHTML = unit_info.description;
        } else {
            this.nameTarget.innerHTML = 'Unit Info';
            this.descriptionTarget.innerHTML = 'No unit size information available';
        }
    }

    close() {
        this.element.classList.remove('show', 'd-block');
        document.getElementsByClassName("modal-backdrop")[0].remove();
    }
}